import { Routes, Route, Navigate } from 'react-router-dom';
import { AppContainer } from '../container';
import { CONTAINER_TYPE } from '../constants/containerType';
import { mapJobTitleToRole } from '../utils/roleMapper';
import { DATA_STORE_KEYS, DataStore } from '../providers/dataStore';
import AdminContainer from '../container/AdminContainer';
import HardReset from '../container/HardReset';

const AppRoutes = () => {
    const userCurrentRole = DataStore.getItem(DATA_STORE_KEYS.USER_CURRENT_ROLE);
    if (!userCurrentRole) {
        DataStore.removeItem(DATA_STORE_KEYS.IS_LOGGEDIN);
        DataStore.removeItem(DATA_STORE_KEYS.USER);
        DataStore.removeItem(DATA_STORE_KEYS.USER_DATA);
        DataStore.removeItem(DATA_STORE_KEYS.USER_EMPLOYEE);
    }

    const isAuthenticated = DataStore.getItem(DATA_STORE_KEYS.IS_LOGGEDIN) === 'true';
    const userRole = isAuthenticated ? mapJobTitleToRole(userCurrentRole) : CONTAINER_TYPE.LOGIN;

    return (
        <Routes>
            <Route
                path="/*"
                element={
                    isAuthenticated ? (
                        <AppContainer containerType={userRole} />
                    ) : (
                        <Navigate to="/login" replace />
                    )
                }
            />
            <Route
                path="/login"
                element={
                    !isAuthenticated ? (
                        <AppContainer containerType={CONTAINER_TYPE.LOGIN} />
                    ) : (
                        <Navigate to="/" replace />
                    )
                }
            />
            <Route path="/hardreset" element={<HardReset />} />
            <Route path="/admin/users" element={<AdminContainer />} />
            <Route path="/admin/roles" element={<AdminContainer />} />
            <Route path="/admin/role/:role_id/edit_widgets" element={<AdminContainer />} />
            <Route path="/admin/role/add_widget" element={<AdminContainer />} />
        </Routes>
    );
};
export default AppRoutes;
